import { observer } from 'mobx-react'

const UIFilterPercent = ({ value, decimals = 2 }) =>
  Math.abs(value).toLocaleString('pt-br', { style: 'percent', maximumFractionDigits: decimals, minimumFractionDigits: decimals })

export default observer(UIFilterPercent)
